// src/app/helpers/ga4.js

const waitForGtag = () =>
  new Promise((resolve) => {
    if (typeof window.gtag === 'function') {
      resolve()
      return
    }

    let attempts = 0
    const maxAttempts = 50

    const checkGtag = setInterval(() => {
      attempts += 1

      if (typeof window.gtag === 'function') {
        clearInterval(checkGtag)
        resolve()
      } else if (attempts >= maxAttempts) {
        clearInterval(checkGtag)
        resolve()
      }
    }, 100)
  })

export const setGA4Userproperties = async (userProperties = {}) => {
  if (process.env.REACT_APP_GA4_ON !== 'true') {
    return
  }
  if (typeof window === 'undefined') {
    return
  }
  if (typeof window.gtag !== 'function') {
    await waitForGtag()
  }
  if (typeof window.gtag !== 'function') {
    return
  }
  window.gtag('set', 'user_properties', {
    campus: userProperties.campus,
    user_type: userProperties.userType,
    affiliation: userProperties.affiliation,
  })
}

export const trackGA4Event = async (eventData = {}) => {
  if (process.env.REACT_APP_GA4_ON !== 'true') {
    return
  }

  if (typeof window === 'undefined') {
    return
  }

  if (typeof window.gtag !== 'function') {
    await waitForGtag()
  }

  if (typeof window.gtag !== 'function') {
    return
  }

  const payload = {
    debug_mode:
      eventData.debug_mode || process.env.REACT_APP_GA4_DEBUG === 'true',
    transport_type: 'beacon',
    module: eventData.module,
    object: eventData.object,
    object_id: eventData.objectId,
    action: eventData.action,
    action_context: eventData.actionContext,
    action_context_value: eventData.actionContextValue,
    login_method: eventData.loginMethod,
    page: eventData.page || window.location.pathname,
    route: eventData.route || window.location.pathname,
    url: eventData.url || window.location.href,
    app_source: eventData.appSource,
    app_layout: eventData.appLayout,
    user_campus: eventData.userCampus,
    user_type: eventData.userType,
    user_affiliation: eventData.userAffiliation,
  }

  // Remove undefined values
  Object.keys(payload).forEach(
    (key) => payload[key] === undefined && delete payload[key],
  )

  window.gtag('event', eventData.eventName || 'uxp_interaction', payload)
}
